import { render } from "./MyHeader.vue?vue&type=template&id=bad91dd2&scoped=true"
import script from "./MyHeader.vue?vue&type=script&lang=js"
export * from "./MyHeader.vue?vue&type=script&lang=js"

import "./MyHeader.vue?vue&type=style&index=0&id=bad91dd2&scoped=true&lang=css"
import "./MyHeader.vue?vue&type=style&index=1&id=bad91dd2&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bad91dd2"]])

export default __exports__